import { useState, useEffect, useRef, useCallback } from "react";

import Hero from "components/organisms/hero/index.jsx";
import './Banners.scss';

export const Banners = ({ parameters }) => {
  const [banners, setBanners] = useState(parameters?.banners ?? []);
  const [current, setCurrent] = useState(0);
  const timeoutRef = useRef(null);

  useEffect(() => {
    if (!banners.length && parameters?.banners?.length) {
      setBanners(parameters.banners);
    }
  }, [banners.length, parameters?.banners]);

  const handleTransition = useCallback((e) => {
    if (e) {
      e.preventDefault();
      clearTimeout(timeoutRef.current);
    }
    setCurrent((current) => {
      return banners[current+1] ? current+1 : 0;
    });
  }, [banners]);

  useEffect(() => {
    if (!banners.length) {
      return;
    }
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
      timeoutRef.current = null;
    }

    timeoutRef.current = setInterval(() => {
      handleTransition();
    }, 10000);

    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    }
  }, [banners.length, handleTransition]);
  
  if (!banners.length) {
    return null;
  }

  return (
    <Hero type="color" color="orange">
      <div className="banners-block" id="banners-block">
        {banners.map((banner, i) => (
          <div key={i} className={`banner`} style={i === 0 && current > 0 ? { marginLeft: `-${current*75}%`} : undefined} onClick={i !== current ? handleTransition : undefined}>
            <a href={banner.url ?? '#'}>
              {banner.images[0] && (
                <img src={`https://territorioyacopini.com.ar${banner.images[0].path}`} alt={banner.name} width="100%" height="auto" className={getImageType(banner.images[0])} />
              )}
              {banner.images[1] && (
                <img src={`https://territorioyacopini.com.ar${banner.images[1]?.path}`} alt={banner.name} width="100%" height="auto" className={getImageType(banner.images[1])} />
              )}
            </a>
          </div>
        ))}
        {banners.length > 1 && (
          <div className={`banner`} onClick={handleTransition}>
            {banners[0].images[0] && (
              <img src={`https://territorioyacopini.com.ar${banners[0].images[0].path}`} alt={banners[0].name} width="100%" height="auto" className={getImageType(banners[0].images[0])} />
            )}
            {banners[0].images[1] && (
              <img src={`https://territorioyacopini.com.ar${banners[0].images[1]?.path}`} alt={banners[0].name} width="100%" height="auto" className={getImageType(banners[0].images[1])} />
            )}
          </div>
        )}
      </div>
      <div>
        <div style={{ display: 'flex', justifyContent: 'center', gap: '8px' }}>
          {banners.map((_, index) => (
            <button
              key={index}
              onClick={() => { setCurrent(index); if (timeoutRef.current) { clearTimeout(timeoutRef.current); }}}
              style={{
                width: '12px',
                height: '12px',
                borderRadius: '50%',
                border: 'none',
                backgroundColor: current === index ? '#333' : '#ccc',
                cursor: 'pointer',
              }}
              aria-label={`Go to slide ${index + 1}`}
            />
          ))}
        </div>
      </div>
    </Hero>
  )
}

function getImageType(image) {
  if (image.size[0] > image.size[1]) {
    return 'desktop';
  }
  return 'mobile';
}